import $axios from './api';

export const list = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/purchase/list', payload);
	return data;
};

export const createAuthorPayment = async () => {
	const { data } = await $axios.post('/v1/author/authorPayment/create');
	return data;
};

export const authorPaymentList = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/authorPayment/list', payload);
	return data;
};

export const authorPaymentCheck = async () => {
	const { data } = await $axios.post('/v1/author/authorPayment/check');
	return data;
};

export const authorPaymentGet = async (id) => {
	const { data } = await $axios.get(`/v1/author/authorPayment/${id}`);
	return data;
};

export const metricsSales = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/sales', payload);
	return data;
};

export const metricsRefunds = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/refunds', payload);
	return data;
};

export const refundList = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/refund/list', payload);
	return data;
};

export const metricsPayouts = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/payouts', payload);
	return data;
};

export const metricsProducts = async () => {
	const { data } = await $axios.get('/v1/author/metrics/products');
	return data;
};

export const metricsPurchases = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/purchases', payload);
	return data;
};

export const metricsLikes = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/likes', payload);
	return data;
};

export const metricsProgressLectures = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/progress/lectures', payload);
	return data;
};

export const metricsProgressLecturesSummary = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/progress/lectures/summary', payload);
	return data;
};

export const metricsProgressQuizzes = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/progress/quizzes', payload);
	return data;
};

export const metricsProgressQuizzesSummary = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/metrics/progress/quizzes/summary', payload);
	return data;
};